import React from 'react';
import Tooltip from 'components/shared/Tooltip';
import { Lock } from 'react-feather';
import DateFormat from 'constants/date_format.js';
import { TYPES } from 'constants/config';

const RequiredAttendance = attendance => {
  if (
    attendance.attendance.rsvp_status === 'will_attend' ||
    attendance.attendance.rsvpStatus === 'will_attend'
  ) {
    return (
      <div className="JourneyBuilderContent-attendance">
        {t('journeys.builder.awaiting_attendance')}
      </div>
    );
  }

  return (
    <div className="JourneyBuilderContent-attendance">
      {t('journeys.builder.attendance_required')}
    </div>
  );
};

const StatusIndicator = ({
  locked,
  displayAddedAt,
  updatedAt,
  addedAfterCompletion,
  attendance = false,
  type,
}) => {
  return (
    <div className="JourneyAvailability">
      {locked && (
        <Tooltip
          position="top"
          text={
            displayAddedAt
              ? t('journeys.viewer.added_after')
              : t('journeys.viewer.locked')
          }
        >
          <Lock className="JourneyAvailability-lock" size={20} />
        </Tooltip>
      )}
      {!locked && type === TYPES.EVENT && (
        <RequiredAttendance attendance={attendance} />
      )}
      {displayAddedAt && (
        <div className="JourneyAvailability-text">
          {`${t('journeys.viewer.added_on')} ${moment(updatedAt).format(
            DateFormat.MONTH_DAY_YEAR_SHORT,
          )}`}
        </div>
      )}
      {addedAfterCompletion && (
        <p className="JourneyAvailability-text">
          {t('journeys.viewer.added_after_completion')}
        </p>
      )}
    </div>
  );
};

export default StatusIndicator;
